/* Cinch theme: cart (add, change, drawer), header menu, small helpers */
(function () {
  'use strict';

  var T = window.cinchTheme || {};
  var R = T.routes || { root: '/', cart: '/cart', cartAdd: '/cart/add', cartChange: '/cart/change' };
  var S = T.strings || {};
  var toastTimer;
  var lastFocus = null;
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }

  function toast(msg) {
    var t = $('[data-toast]');
    if (!t || !msg) return;
    t.textContent = msg;
    t.classList.add('show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.classList.remove('show'); }, 3000);
  }

  function request(url, options) {
    return fetch(url, options).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok) {
          var err = new Error(data.description || data.message || S.error || 'Error');
          err.data = data;
          throw err;
        }
        return data;
      });
    });
  }

  var jsonHeaders = { 'Content-Type': 'application/json', 'Accept': 'application/json' };

  function setCount(n) {
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = n;
      el.hidden = !n;
    });
  }

  function drawer() { return $('[data-cart-drawer]'); }

  function openDrawer() {
    var d = drawer();
    if (!d) return;
    lastFocus = document.activeElement;
    d.hidden = false;
    document.body.classList.add('no-scroll');
    var c = $('.cart-drawer__head [data-cart-close]', d);
    if (c) c.focus();
  }

  function closeDrawer() {
    var d = drawer();
    if (!d || d.hidden) return;
    d.hidden = true;
    document.body.classList.remove('no-scroll');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function refreshDrawer() {
    var d = drawer();
    if (!d) return Promise.resolve();
    return fetch(R.root + '?sections=cart-drawer')
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        var html = sections && sections['cart-drawer'];
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = $('[data-cart-drawer-content]', doc);
        var cur = $('[data-cart-drawer-content]', d);
        if (fresh && cur) cur.innerHTML = fresh.innerHTML;
      });
  }

  function refreshCount() {
    return request(R.cart + '.js', { headers: { 'Accept': 'application/json' } }).then(function (cart) {
      setCount(cart.item_count);
      return cart;
    });
  }

  function add(items) {
    return request(R.cartAdd + '.js', {
      method: 'POST',
      headers: jsonHeaders,
      body: JSON.stringify({ items: items })
    }).then(function (res) {
      return refreshCount().then(refreshDrawer).then(function () { return res; });
    });
  }

  function flyToCart(originEl) {
    var cartBtn = $('.cart-btn');
    if (!originEl || !cartBtn) return Promise.resolve();
    if (reduceMotion) {
      cartBtn.classList.add('bump');
      setTimeout(function () { cartBtn.classList.remove('bump'); }, 260);
      return Promise.resolve();
    }
    var o = originEl.getBoundingClientRect();
    var c = cartBtn.getBoundingClientRect();
    var sx = o.left + o.width / 2, sy = o.top + o.height / 2;
    var ex = c.left + c.width / 2, ey = c.top + c.height / 2;
    var bubble = document.createElement('span');
    bubble.className = 'cart-bubble';
    bubble.setAttribute('aria-hidden', 'true');
    bubble.style.left = sx + 'px';
    bubble.style.top = sy + 'px';
    bubble.style.setProperty('--tx', (ex - sx) + 'px');
    bubble.style.setProperty('--ty', (ey - sy) + 'px');
    document.body.appendChild(bubble);
    return new Promise(function (resolve) {
      var done = false;
      function finish() {
        if (done) return;
        done = true;
        bubble.remove();
        cartBtn.classList.add('bump');
        setTimeout(function () { cartBtn.classList.remove('bump'); }, 260);
        resolve();
      }
      bubble.addEventListener('animationend', finish, { once: true });
      setTimeout(finish, 900);
    });
  }

  function afterAdd() {
    if (T.cartType === 'drawer' && drawer()) {
      openDrawer();
    } else {
      window.location.href = R.cart;
    }
  }

  function change(line, quantity) {
    return request(R.cartChange + '.js', {
      method: 'POST',
      headers: jsonHeaders,
      body: JSON.stringify({ line: line, quantity: quantity })
    }).then(function (cart) {
      setCount(cart.item_count);
      if ($('[data-cart-page]')) {
        window.location.reload();
        return cart;
      }
      return refreshDrawer().then(function () { return cart; });
    });
  }

  function changeLine(wrap, quantity) {
    if (!wrap) return;
    var line = parseInt(wrap.getAttribute('data-line'), 10);
    if (!line) return;
    wrap.classList.add('is-busy');
    change(line, quantity).catch(function (err) {
      toast(err.message || S.error);
      if ($('[data-cart-page]')) {
        window.location.reload();
      } else {
        refreshDrawer();
      }
    });
  }

  document.addEventListener('click', function (e) {
    var target = e.target;
    if (!target || !target.closest) return;
    var el;

    el = target.closest('[data-cart-toggle]');
    if (el && T.cartType === 'drawer' && drawer()) {
      e.preventDefault();
      refreshDrawer().then(openDrawer, openDrawer);
      return;
    }

    if (target.closest('[data-cart-close]')) {
      closeDrawer();
      return;
    }

    el = target.closest('[data-qty-step]');
    if (el) {
      var wrap = el.closest('[data-line]');
      var input = wrap && $('[data-qty-input]', wrap);
      if (!input) return;
      var next = Math.max(0, (parseInt(input.value, 10) || 0) + parseInt(el.getAttribute('data-qty-step'), 10));
      input.value = next;
      changeLine(wrap, next);
      return;
    }

    el = target.closest('[data-cart-remove]');
    if (el) {
      e.preventDefault();
      changeLine(el.closest('[data-line]'), 0);
      return;
    }

    el = target.closest('[data-menu-toggle]');
    if (el) {
      var nav = $('[data-site-nav]');
      if (!nav) return;
      var open = nav.classList.toggle('is-open');
      el.setAttribute('aria-expanded', open ? 'true' : 'false');
    }
  });

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.matches) return;
    if (t.matches('[data-qty-input]')) {
      var wrap = t.closest('[data-line]');
      var q = Math.max(0, parseInt(t.value, 10) || 0);
      t.value = q;
      changeLine(wrap, q);
    } else if (t.matches('[data-auto-submit]') && t.form) {
      t.form.submit();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeDrawer();
  });

  window.CinchCart = {
    add: add,
    afterAdd: afterAdd,
    flyToCart: flyToCart,
    change: change,
    refresh: refreshDrawer,
    refreshCount: refreshCount,
    open: openDrawer,
    close: closeDrawer,
    toast: toast
  };
})();
